export default "__VITE_ASSET__BHKz17z$__"